import React, { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import { hasRole } from "../../util/utilFunction";
import "./DashboardPPIC.css";
import moment from "moment";

const DashboardPPIC = ({ data }) => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);
  const isLeader = hasRole(dataUser, "produksi_leader");

  const [isOn, setIsOn] = useState(true);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/emergency`,
      { tim: dataUser.tim, dataType: "emergency", type: "get" },
      dataUser.auth,
      setIsOn,
      ""
    );
  }, []);

  return (
    <div className="flex_wrap">
      {data &&
        data.map((obj) => {
          const downtime = obj.downtime ? obj.downtime : 0;
          const dataCounterAwal = obj.counterAwal ? obj.counterAwal : 0;
          const dataCounterAkhir = obj.counterAkhir ? obj.counterAkhir : 0;
          const dataTargetProduk = obj.targetProduk ? obj.targetProduk : 0;
          const dataAktualCavity = obj.aktualCavity ? obj.aktualCavity : 0;
          const dataSisaShiftSebelumnya = obj.sisaShiftSebelumnya
            ? obj.sisaShiftSebelumnya
            : 0;
          const dataLastCounterAkhir = obj.lastCounterAkhir
            ? obj.lastCounterAkhir
            : 0;
          const dataLastSisaShiftSebelumnya =
            obj.lastSisaShiftSebelumnya && dataUser.tim === 1
              ? obj.lastSisaShiftSebelumnya
              : 0;

          const formulaTargetProduksi = dataTargetProduk * dataAktualCavity;

          const formula =
            (8 * 3600 - downtime * 60) / (dataCounterAkhir - dataCounterAwal);

          const indicatorCavity =
            obj.jumlahBarang + obj.jumlahNG ===
            (obj.counterAkhir - obj.counterAwal) * obj.aktualCavity;

          const checkSisaShift =
            obj.jumlahBarang + dataLastSisaShiftSebelumnya ===
            obj.aktualBarang + dataSisaShiftSebelumnya;

          return (
            <div
              className="wrapper_card_approval_laporan"
              style={
                dataLastCounterAkhir !== dataCounterAwal
                  ? { border: "2px solid red" }
                  : {}
              }
            >
              <div
                className="section_approval_laporan"
                style={{
                  margin: "12px 0 6px 0",
                }}
              >
                <p style={{ fontSize: "10px", margin: 0 }}>
                  {dataUser.tim === 1 ? "Form-PROD-A28-R2" : "Form-PROD-A28-R8"}
                </p>
                <p style={{ fontSize: "10px", margin: 0 }}>
                  {moment(obj.dateSubmit).format("HH:mm:ss")}
                </p>
              </div>
              <div className="section_approval_laporan">
                <p
                  className="tittle-machine-dashboard"
                  style={{ margin: "0px 0 6px 0" }}
                >
                  Mesin&nbsp;{obj.mesin}
                </p>
                <p style={{ margin: "0 0 6px 0" }}>
                  {moment(obj.date).format("DD MMM YYYY")}
                </p>
                <p
                  className="tittle-customer-dashboard"
                  style={{ margin: "0px 0 6px 0" }}
                >
                  {obj.customer}
                </p>
              </div>
              <div className="flex_justify_between">
                <p style={{ margin: "6px 0" }}>{obj.operator}</p>
              </div>
              <div className="flex_justify_between">
                <p
                  className="font_bold"
                  style={{ margin: "6px 0", fontWeight: "bold" }}
                >
                  {obj.moldType}
                </p>
              </div>
              <div className="flex_justify_between">
                <p className="font_bold" style={{ margin: "6px 0" }}>
                  {obj.color}
                </p>
                <p
                  className="tittle-reject-dashboard"
                  style={{ fontSize: "14px" }}
                >
                  Reject:&nbsp;
                  <label style={{ color: "red", fontWeight: 500 }}>
                    {(
                      (obj.jumlahNG / (obj.jumlahNG + obj.jumlahBarang)) *
                      100
                    ).toFixed(1)}
                    %
                  </label>
                </p>

                <p style={{ textAlign: "end", margin: "6px 0" }}>
                  Shift&nbsp;{obj.shift}
                </p>
              </div>
              <div className="flex_justify_between"></div>
              {!isOn ? (
                <div className="flex_justify_between">
                  <div style={{ width: "50%" }}>
                    <p
                      style={
                        formulaTargetProduksi > obj.jumlahBarang + obj.jumlahNG
                          ? {
                              color: "red",
                              fontWeight: "bold",
                              margin: "6px 0",
                            }
                          : {
                              fontWeight: "bold",
                              margin: "6px 0",
                            }
                      }
                    >
                      Target Produksi
                    </p>
                    <p
                      style={
                        formulaTargetProduksi > obj.jumlahBarang + obj.jumlahNG
                          ? { color: "red", margin: "12px 0 6px 0" }
                          : { margin: "12px 0 6px 0" }
                      }
                    >
                      {formulaTargetProduksi.toFixed(0)}
                    </p>
                  </div>
                  <div style={{ width: "40%" }}>
                    <p
                      style={
                        28800 / dataTargetProduk < formula &&
                        28800 / dataTargetProduk !== Infinity
                          ? {
                              color: "red",
                              fontWeight: "bold",
                              margin: "6px 0",
                            }
                          : {
                              fontWeight: "bold",
                              margin: "6px 0",
                            }
                      }
                    >
                      Target CT
                    </p>
                    <p
                      style={
                        28800 / dataTargetProduk < formula &&
                        28800 / dataTargetProduk !== Infinity
                          ? { color: "red", margin: "12px 0 6px 0" }
                          : { margin: "12px 0 6px 0" }
                      }
                    >
                      {28800 / dataTargetProduk === Infinity
                        ? 0
                        : (28800 / dataTargetProduk).toFixed(2)}
                      &nbsp;Detik
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
              {!isOn ? (
                <div className="flex_justify_between">
                  <div style={{ width: "50%" }}>
                    {(obj.jumlahBarang / formulaTargetProduksi) * 100 < 80 ? (
                      <>
                        <p
                          className="font_bold"
                          style={{
                            margin: "6px 0",
                            fontWeight: "bold",
                            color: "red",
                          }}
                        >
                          Pencapaian:&nbsp;
                        </p>
                        <p
                          className="font_14"
                          style={{
                            margin: "12px 0 6px 0",
                            color: "red",
                            fontWeight: 600,
                            textAlign: "left",
                          }}
                        >
                          {(
                            (obj.jumlahBarang / formulaTargetProduksi) *
                            100
                          ).toFixed(0)}
                          %
                        </p>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div style={{ width: "40%" }}></div>
                </div>
              ) : (
                ""
              )}
              <div className="flex_justify_between">
                <div style={{ width: "50%" }}>
                  <p
                    className="font_bold"
                    style={{ margin: "6px 0", fontWeight: "bold" }}
                  >
                    Isi Per Kemasan
                  </p>
                  <p className="font_14" style={{ margin: "12px 0 6px 0" }}>
                    {obj.isiPerKemasan}&nbsp;Pcs
                  </p>
                </div>
                {!isOn ? (
                  <div style={{ width: "40%" }}>
                    <p
                      className="font_bold"
                      style={{ margin: "6px 0", fontWeight: "bold" }}
                    >
                      Aktual CT
                    </p>
                    <p className="font_14" style={{ margin: "12px 0 6px 0" }}>
                      {formula === Infinity ? 0 : formula.toFixed(1)}&nbsp;Detik
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="flex_justify_between">
                <div style={{ width: "50%" }}>
                  <p
                    className="font_bold"
                    style={{ margin: "6px 0", fontWeight: "bold" }}
                  >
                    Aktual Cavity
                  </p>
                  <p className="font_14" style={{ margin: "12px 0 6px 0" }}>
                    {obj.aktualCavity}
                  </p>
                </div>
                <div style={{ width: "40%" }}>
                  <p
                    className="font_bold"
                    style={{ margin: "6px 0", fontWeight: "bold" }}
                  >
                    Counter Akhir
                  </p>
                  <p className="font_14" style={{ margin: "12px 0 6px 0" }}>
                    {obj.counterAkhir}
                  </p>
                </div>
              </div>
              <div className="flex_justify_between">
                <div style={{ width: "50%" }}>
                  <p
                    className="font_bold"
                    style={{ margin: "6px 0", fontWeight: "bold" }}
                  >
                    Counter Awal
                  </p>
                  <p className="font_14" style={{ margin: "12px 0 6px 0" }}>
                    {obj.counterAwal}
                  </p>
                </div>
                <div style={{ width: "40%" }}>
                  <p
                    className="font_bold"
                    style={{ margin: "6px 0", fontWeight: "bold" }}
                  >
                    Selisih Counter
                  </p>
                  <p className="font_14" style={{ margin: "12px 0 6px 0" }}>
                    {obj.counterAkhir - obj.counterAwal}
                  </p>
                </div>
              </div>
              <div className="flex_justify_between">
                <div style={{ width: "50%" }}>
                  <p
                    className="font_bold"
                    style={
                      dataLastSisaShiftSebelumnya > 0
                        ? checkSisaShift && dataUser.tim === 1
                          ? { margin: "6px 0", fontWeight: "bold" }
                          : {
                              margin: "6px 0",
                              fontWeight: "bold",
                              color: "red",
                            }
                        : { margin: "6px 0", fontWeight: "bold" }
                    }
                  >
                    {dataUser.tim === 2
                      ? "Sisa Shift Sebelumnya"
                      : `Receh Shift ${obj.shift}`}
                  </p>
                  <p
                    className="font_14"
                    style={
                      dataLastSisaShiftSebelumnya > 0
                        ? checkSisaShift && dataUser.tim === 1
                          ? { margin: "12px 0 6px 0" }
                          : {
                              margin: "12px 0 6px 0",
                              color: "red",
                            }
                        : { margin: "12px 0 6px 0" }
                    }
                  >
                    {obj.sisaShiftSebelumnya ? obj.sisaShiftSebelumnya : 0}
                    &nbsp;Pcs
                  </p>
                </div>
                {!isOn ? (
                  <div style={{ width: "40%" }}>
                    <p
                      className="font_bold"
                      style={{ margin: "6px 0", fontWeight: "bold" }}
                    >
                      Down Time
                    </p>
                    <p className="font_14" style={{ margin: "12px 0 6px 0" }}>
                      {downtime}&nbsp;Menit
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="flex_justify_between">
                <div style={{ width: "50%" }}>
                  <p
                    className="font_bold"
                    style={{
                      margin: "6px 0",
                      fontWeight: "bold",
                      color: "lightseagreen",
                    }}
                  >
                    Barang OK
                  </p>
                  <p
                    className="font_14"
                    style={{ margin: "12px 0 6px 0", color: "lightseagreen" }}
                  >
                    {obj.jumlahBarang}&nbsp;Pcs
                  </p>
                </div>
                <div style={{ width: "40%" }}>
                  <p
                    className="font_bold"
                    style={{ margin: "6px 0", fontWeight: "bold" }}
                  >
                    Jumlah "NG"
                  </p>
                  <p className="font_14" style={{ margin: "12px 0 6px 0" }}>
                    {obj.jumlahNG}&nbsp;Pcs
                  </p>
                </div>
              </div>
              {isLeader ? (
                <div
                  style={
                    !indicatorCavity
                      ? { width: "40%", color: "red" }
                      : { width: "40%" }
                  }
                >
                  <p
                    className="font_bold"
                    style={{ fontWeight: "bold", margin: "6px 0" }}
                  >
                    Indikator Laporan
                  </p>
                  <p className="font_14">{!indicatorCavity ? "SALAH" : ""}</p>
                </div>
              ) : (
                ""
              )}
              {dataUser.tim === 2 ? (
                <div className="flex_justify_between">
                  <div style={{ minWidth: "148px" }}>
                    <p>Produk OK + SISA</p>
                    <p>
                      {Number(obj.jumlahBarang) +
                      Number(obj.sisaShiftSebelumnya)
                        ? Number(obj.jumlahBarang) +
                          Number(obj.sisaShiftSebelumnya)
                        : 0}
                    </p>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="flex_justify_between">
                <div style={{ width: "50%" }}>
                  <p
                    className="font_bold"
                    style={{ margin: "6px 0", fontWeight: "bold" }}
                  >
                    Aktual Barang
                  </p>
                  <p className="font_14" style={{ margin: "12px 0 6px 0" }}>
                    {obj.aktualBarang}&nbsp;Pcs
                  </p>
                </div>
                {dataUser.tim === 2 ? (
                  <div style={{ width: "40%" }}>
                    <p style={{ margin: "6px 0", fontWeight: "bold" }}>
                      Selisih Barang
                    </p>
                    <p style={{ margin: "12px 0 6px 0" }}>
                      {obj.aktualBarang
                        ? Number(obj.aktualBarang) -
                          Number(obj.jumlahBarang) -
                          Number(obj.sisaShiftSebelumnya)
                        : 0}
                      &nbsp;Pcs
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div>
                <div className="flex_justify_between">
                  <p
                    style={{
                      width: "50%",
                      fontWeight: "bold",
                      margin: "6px 0",
                    }}
                  >
                    Perincian "NG"
                  </p>
                  <p
                    style={{
                      width: "40%",
                      fontWeight: "bold",
                      margin: "6px 0",
                    }}
                  >
                    Jumlah
                  </p>
                </div>
                {obj.perincianNG &&
                  obj.perincianNG.map((perincian) => {
                    return (
                      <div className="flex_justify_between">
                        <p
                          style={{
                            fontSize: "14px",
                            width: "50%",
                            margin: "0 0 6px 0",
                          }}
                        >
                          {perincian.id}
                        </p>
                        <p
                          style={{
                            fontSize: "14px",
                            width: "40%",
                            margin: "0 0 6px 0",
                          }}
                        >
                          {perincian.totalNG}&nbsp;Pcs
                        </p>
                      </div>
                    );
                  })}
                {obj.keterangan !== "" || dataUser.tim === 2 ? (
                  <div>
                    <p
                      className="font_bold"
                      style={{ fontWeight: "bold", margin: "6px 0" }}
                    >
                      Keterangan
                    </p>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: obj.keterangan.replace(/\n/g, "<br/>"),
                      }}
                      className="size-keterangan-dashboard"
                      style={{ lineHeight: "18px" }}
                    />
                  </div>
                ) : (
                  <>
                    <div
                      style={{
                        width: "100%",
                      }}
                    >
                      <table
                        style={{
                          width: "100%",
                        }}
                      >
                        <tr>
                          <th
                            style={{
                              padding: "8px 0px 8px 12px",
                              textAlign: "left",
                              fontSize: "12px",
                              position: "static",
                            }}
                          >
                            Jam
                          </th>
                          <th
                            style={{
                              padding: "8px 0px 8px 12px",
                              textAlign: "left",
                              fontSize: "12px",
                              position: "static",
                            }}
                          >
                            Keterangan
                          </th>
                        </tr>

                        {obj.dataKeterangan.map((ele) => {
                          return (
                            <tr>
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: "10px",
                                  paddingTop: "8px",
                                  whiteSpace: "nowrap",
                                  fontSize: "12px",
                                }}
                              >
                                {ele.jam}
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  paddingLeft: "10px",
                                  paddingTop: "8px",
                                  wordBreak: "break-all",
                                  fontSize: "12px",
                                }}
                              >
                                {ele.keterangan}
                              </td>
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};
export default DashboardPPIC;
